<template>
<!-- 视频管理 -->
  <div id="videoManager">
    <div class="allMenuHead">
      <div v-if="$childMenu.indexOf('轮播图配置') >= 0" :class="step ? 'active' : ''" @click="toUrl('carouselList', 2)" class="d_i headTab p_r">轮播图配置<div class="p_a"></div></div>
      <div v-if="$childMenu.indexOf('视频管理') >= 0" :class="!step ? 'active' : ''" @click="toUrl('videoList', 1)" class="d_i headTab p_r">视频管理<div class="p_a"></div></div>
    </div>
    <div class="allHeaderRouter">
      <transition name="fadeLeft">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
let Time
  export default {
    name: 'videoManager',
    data () {
      return {
        step: true,
        isSystemAdmin: window.sessionStorage.getItem('isSystemAdmin'),
        appowner: JSON.parse(window.sessionStorage.getItem('nowApp'))
      }
    },
    created () {
      Time = setInterval(p => {
        if (window.location.href.indexOf('carouselList') >= 0) {
          this.step = true
        }
        if (window.location.href.indexOf('videoList') >= 0) {
          this.step = false
        }
      }, 100)
    },
    destroyed () {
      clearInterval(Time)
    },
    methods: {
      toUrl (url, num) {
        if (num === 1) {
          this.step = true
        } else {
          this.step = false
        }
        this.$router.push({
          name: url
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/videoManager/videoManager.vue